import React, { useContext } from 'react';
import { navigate } from 'gatsby';
import { Img } from 'react-image';
import { Skeleton, Box, Text } from '@chakra-ui/react';
import { endpoints } from '../../config';
import * as S from './styles';
import { StoreContext } from '../../context/Store';
import PriceTag from '../PriceTag';
import RatingStars from '../ProductRatings/RatingStars';
import { calculateAverageRating, getVariantsPriceRange } from '../../helpers';
import Availability from '../Availability';
import { jsx as ___EmotionJSX } from "@emotion/react";
const GridItem = _ref => {
  let {
    product
  } = _ref;
  const {
    storeRootPath
  } = useContext(StoreContext);
  const onNavigate = () => {
    navigate(`${storeRootPath}/${product.category.slug}/${product.slug}/${product.id}`, {
      state: product
    });
  };
  return ___EmotionJSX(S.GridItem, {
    onClick: () => onNavigate()
  }, ___EmotionJSX("div", {
    className: "int-image-container"
  }, product.images.length === 0 ? ___EmotionJSX(Img, {
    src: "https://placehold.jp/333/ffffff/200x200.png?text=Kein%20Bild",
    alt: "Kein Bild",
    loader: ___EmotionJSX(Skeleton, {
      height: "200px"
    })
  }) : ___EmotionJSX(Img, {
    src: `${endpoints.thumbnails}/${product.images.filter(image => !!image.file_id)[0].file_id.private_hash}?key=e-grid-thumbnail`,
    alt: product.display_name,
    unloader: ___EmotionJSX("img", {
      src: "https://placehold.jp/333/ffffff/200x200.png?text=Kein%20Bild",
      alt: "Kein Bild"
    }),
    loader: ___EmotionJSX(Skeleton, {
      height: "200px"
    })
  })), ___EmotionJSX(Box, {
    p: 2
  }, product.ratings.length > 0 && ___EmotionJSX(RatingStars, {
    rating: calculateAverageRating(product.ratings),
    count: product.ratings.length,
    showTooltip: true
  }), product.manufacturer && ___EmotionJSX("p", {
    className: "int-product-manufacturer",
    title: product.manufacturer.display_name
  }, product.manufacturer.display_name), ___EmotionJSX("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, ___EmotionJSX(Availability, {
    product: product,
    asBubble: true
  }), ___EmotionJSX("p", {
    className: "int-product-name",
    style: {
      marginLeft: '5px'
    },
    title: product.display_name
  }, product.display_name)), ___EmotionJSX(Text, {
    color: "brand.500",
    fontWeight: "bold",
    pt: 2
  }, product.product_variants.length > 0 ? ___EmotionJSX(PriceTag, {
    priceRange: getVariantsPriceRange(product.product_variants),
    showInfo: false
  }) : ___EmotionJSX(PriceTag, {
    price: product.price_brutto,
    showInfo: false
  }))));
};
export default GridItem;